
import { createRoot } from "react-dom/client";
import { Toaster } from "sileo";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { Logger } from "./utils/logger";
import "./index.css";
import "./styles/oauth.css";
import "./styles/auth.css";

Logger.info("[Main] Raiso frontend bootstrap started");

// TODO [UX]: Ajouter ErrorBoundary par page/section (pas seulement à la racine)
createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
    <Toaster
      position="top-right"
      options={{
        fill: "color-mix(in srgb, var(--color-surface) 70%, transparent)",
        roundness: 12,
        styles: {
          // Le `text-transform: capitalize` par défaut de sileo (Title Case anglais) est
          // neutralisé par une vraie règle CSS `[data-sileo-title]{text-transform:none!important}`
          // en fin de src/index.css (V4-FRONT-TOAST-TITLECASE-PATTERN). NB : passer `normal-case!`
          // ici serait un no-op (classe absente du Tailwind figé + non reconnue par sileo).
          title: "font-medium!",
          description: "text-sm mt-1!",
        }
      }}
    />
  </ErrorBoundary>
);
  